var _path, _g, _path2, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBgAbstract({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 900,
    viewBox: "0 0 1440 900",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_499_7541)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_499_7541",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 337,
    height: 626
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M337 626L337 6.29444e-05L0.000619174 4.82137e-05L0.000591811 626L337 626Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_499_7541)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M-121.777 -96.8403L191.433 257.5C203.213 270.83 206.163 289.09 198.033 298.29L43.2932 473.35C35.1532 482.55 19.0132 479.21 7.23315 465.89L-305.977 111.55C-317.757 98.2197 -320.707 79.9597 -312.577 70.7597L-157.837 -104.3C-149.697 -113.5 -133.557 -110.16 -121.777 -96.8403Z",
    fill: "#EBD7F1",
    fillOpacity: 0.56
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M96.6406 -230.16L232.991 -75.9003C238.121 -70.1003 216.031 -35.7103 183.661 0.919662L-432.109 697.54C-464.479 734.16 -494.879 759.15 -500.009 753.35L-636.359 599.09C-641.489 593.29 -619.399 558.9 -587.029 522.27L28.7405 -174.35C61.1105 -210.97 91.5106 -235.96 96.6406 -230.16Z",
    fill: "#EBD7F1",
    fillOpacity: 0.56
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-226.309 204.35L-59.5385 15.6801C-41.9585 -4.19993 -13.4686 -4.19993 4.11143 15.6801L170.881 204.35C188.461 224.23 188.461 256.47 170.881 276.35L4.11141 465.02C-13.4686 484.9 -41.9586 484.9 -59.5386 465.02L-226.309 276.35C-243.889 256.47 -243.889 224.23 -226.309 204.35Z",
    stroke: "#EBD7F1",
    strokeOpacity: 0.56,
    strokeWidth: 0.31,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.63,
    d: "M-250.249 291.42L-95.3491 116.18C-63.9591 80.6699 -13.059 80.6699 18.331 116.18L173.231 291.42C204.621 326.93 204.621 384.52 173.231 420.03L18.3309 595.27C-13.0591 630.78 -63.9591 630.78 -95.3491 595.27L-250.249 420.03C-281.639 384.52 -281.639 326.93 -250.249 291.42Z",
    fill: "#EBEBFE"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_499_7541",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1002,
    y: 222,
    width: 438,
    height: 678
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1440 900L1440 222L1002 222L1002 900L1440 900Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_499_7541)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1628.97 82.6699L2094.31 609.11C2111.81 628.91 2111.81 661.01 2094.31 680.8L1761.45 1057.37C1743.95 1077.17 1715.58 1077.17 1698.08 1057.37L1232.74 530.93C1215.24 511.13 1215.24 479.03 1232.74 459.24L1565.6 82.6699C1583.1 62.8699 1611.47 62.8699 1628.97 82.6699Z",
    fill: "#EBD7F1",
    fillOpacity: 0.56
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1674.11 208.25L1809.87 361.85C1814.98 367.63 1795.43 399.1 1766.21 432.16L1210.48 1060.86C1181.26 1093.91 1153.44 1116.03 1148.33 1110.25L1012.57 956.66C1007.46 950.88 1027.01 919.41 1056.23 886.35L1611.96 257.65C1641.18 224.6 1669 202.48 1674.11 208.26L1674.11 208.25Z",
    fill: "#EBD7F1",
    fillOpacity: 0.56
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1301.62 611.5L1467.67 423.64C1485.17 403.84 1513.54 403.84 1531.04 423.64L1697.09 611.5C1714.59 631.3 1714.59 663.4 1697.09 683.19L1531.04 871.05C1513.54 890.85 1485.17 890.85 1467.67 871.05L1301.62 683.19C1284.12 663.39 1284.12 631.29 1301.62 611.5Z",
    stroke: "#EBD7F1",
    strokeOpacity: 0.56,
    strokeWidth: 0.31,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.63,
    d: "M1277.79 698.2L1432.02 523.71C1463.28 488.35 1513.96 488.35 1545.21 523.71L1699.44 698.19C1730.7 733.55 1730.7 790.88 1699.44 826.25L1545.21 1000.73C1513.95 1036.09 1463.27 1036.09 1432.02 1000.73L1277.79 826.25C1246.53 790.89 1246.53 733.56 1277.79 698.19L1277.79 698.2Z",
    fill: "#EBEBFE"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_499_7541"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 900,
    height: 1440,
    fill: "white",
    transform: "translate(1440 6.29444e-05) rotate(90)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgAbstract);
export default __webpack_public_path__ + "static/media/bg-abstract.b289ce13364749a210842e9dd1067a20.svg";
export { ForwardRef as ReactComponent };